namespace $ {

	export function $shm_list_virtualization_disable() {
		$.$$.$mol_list.prototype.sub_visible = function() {
			return this.sub() as $mol_view[]
		}
	}

	$shm_list_virtualization_disable()

}
